<template>
  <Form url="/renovacoes/config/valor/create" :valor="{}" />
</template>

<script>
import Form from "./Form.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "app-config-renovacoes-valor-create",
  components: {
    Form
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Configurações de Renovação"
      }
    ]);
  }
};
</script>
